import { useEffect } from "react";
import { http, API } from "@/lib/api";

const MUSIC_PLATFORMS = new Set(["spotify", "apple", "amazon", "youtube_music", "deezer"]);

export const InteractionTracker = () => {
  useEffect(() => {
    if (!API) return;
    const onClick = (event) => {
      const video = event.target?.closest?.("button[data-testid^='video-card-'], button[data-testid='video-featured']");
      if (video) {
        const testid = video.getAttribute("data-testid") || "";
        const imageSrc = video.querySelector?.("img")?.getAttribute("src") || "";
        const contentId = testid.startsWith("video-card-")
          ? testid.replace(/^video-card-/, "")
          : imageSrc.match(/\/vi\/([^/?]+)/)?.[1] || "";
        const contentTitle = video.querySelector?.("p")?.textContent?.trim() || "";
        const type = video.closest?.("[data-testid='video-shorts-row']") ? "short" : "video";
        if (contentId) http.post("/track/interaction", { type, platform: "youtube", contentId, contentTitle }).catch(() => {});
        return;
      }

      const link = event.target?.closest?.("a[data-testid]");
      if (!link) return;
      const testid = link.getAttribute("data-testid") || "";
      const track = testid.match(/^track-link-(spotify|apple|amazon|youtube_music|deezer)-(.+)$/);
      const artist = testid.match(/^platform-link-(spotify|apple|amazon|youtube_music|deezer)$/);
      const platform = track?.[1] || artist?.[1];
      if (!platform || !MUSIC_PLATFORMS.has(platform)) return;
      const card = link.closest?.("[data-testid^='track-card-']");
      const cardId = card?.getAttribute("data-testid")?.replace(/^track-card-/, "") || "";
      const title = card?.querySelector?.("h3")?.textContent?.trim() || "";
      http.post("/track/interaction", {
        type: "music",
        platform,
        trackId: track && link.getAttribute("data-link-kind") === "track" ? cardId : "",
        trackTitle: track && link.getAttribute("data-link-kind") === "track" ? title : "",
      }).catch(() => {});
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);
  return null;
};
